import get from 'lodash/get';
import find from 'lodash/find';
import compact from 'lodash/compact';
import map from 'lodash/map';

export const parseGeoCodeApiResponse = addressesList => {
  const parsedText = get(addressesList, 'geocoding.query.parsed_text');
  const unit = get(parsedText, 'unit', get(parsedText, 'flat'));

  return map(addressesList.features, address => {
    const [longitude, latitude] = address.geometry.coordinates;
    const { id, label, country,  street, postalcode, region, county, name, locality, region_a, housenumber } = address.properties;
    return {
      id,
      label,
      country,
      street,
      postalcode,
      region,
      county,
      name,
      locality,
      region_a,
      housenumber,
      latitude,
      longitude,
      unit,
    };
  });
};

export const googleFetchPlaceDetails = async (coordinates, element) => {
  const placeId = get(coordinates, 'id');
  const details = await new Promise((resolve, reject) => {
    if (!placeId) {
      // eslint-disable-next-line prefer-promise-reject-errors
      reject('Invalid place id');
      return;
    }

    new window.google.maps.places.PlacesService(element).getDetails({ placeId }, resolve);
  });
  const postalcode = find(get(details, 'address_components', []), item => item.types.includes('postal_code'));
  const country = find(
    get(details, 'address_components', []),
    item => item.types.includes('administrative_area_level_1') || item.types.includes('country')
  );
  const locality = find(
    get(details, 'address_components', []),
    item => item.types.includes('locality') || item.types.includes('postal_town')
  );
  const neighborhood = find(
    get(details, 'address_components', []),
    item => item.types.includes('neighborhood') || item.types.includes('route')
  );
  const streetNumber = find(get(details, 'address_components', []), item => item.types.includes('street_number'));
  return {
    ...coordinates,
    latitude: details.geometry.location.lat(),
    longitude: details.geometry.location.lng(),
    postalcode: get(postalcode, 'long_name', null),
    country: get(country, 'long_name', null),
    street: compact([get(streetNumber, 'long_name', null), get(neighborhood, 'long_name', null)]).join(' '),
    locality: get(locality, 'long_name', null),
  };
};

export const googlePlacePredictions = (text, countries = []) =>
  new Promise((resolve, reject) => {
    if (!text || typeof window === 'undefined') {
      // eslint-disable-next-line prefer-promise-reject-errors
      reject('Provide valid data');
      return;
    }
    new window.google.maps.places.AutocompleteService().getPlacePredictions(
      {
        input: text,
        componentRestrictions: {
          country: countries,
        },
      },
      resolve
    );
  });
